webpackJsonp([35783957827783],{

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(148);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _voucherAd = __webpack_require__(154);
	
	var _voucherAd2 = _interopRequireDefault(_voucherAd);
	
	var _siteConfig = __webpack_require__(65);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: _siteConfig2.default.siteTitle,
	      meta: [{ name: 'description', content: _siteConfig2.default.siteDescription }]
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'home banner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'banner-info top-off-center text-center' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'uppercase' },
	          'The Ultimate Off Road Experience'
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'spacer white hide-for-small-only' },
	          '\u2015'
	        ),
	        _react2.default.createElement(
	          'h5',
	          { className: 'hide-for-small-only' },
	          _siteConfig2.default.fullDayPrice,
	          ' per person for a full day'
	        ),
	        _react2.default.createElement(
	          'h5',
	          { className: 'hide-for-small-only' },
	          _siteConfig2.default.halfDayPrice,
	          ' per person for a half day'
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'button secondary uppercase large hide-for-small-only', href: '/bookings' },
	          'Bookings'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'small-12 medium-10 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'uppercase' },
	              'Welcome to ',
	              _siteConfig2.default.siteName
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'large-9 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'subheader' },
	              _react2.default.createElement(
	                'small',
	                null,
	                '"This is real off-roading not a glorified passenger ride in mud."'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our vehicles are true competition prepared off road trials vehicles. They are based on the Land Rover chassis and all of them have been used in actual competition. Unlike other places, we don\'t mind if you bash them about a bit or get the seats covered in mud - its what they were built for!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The course is packed with 90 degree banks, mud pits and slopes with lots of natural obstacles. It has been purpose built by expert off road trials course builders, meaning that this is the closest you will get to full on trials driving without entering an actual competition.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Dreaming of Dakar & WRC? This is a fantastic foundation for budding off-road racing & rally drivers.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'A half day\u2019s start time is 10am and we finish around 1.30pm.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'strong',
	                null,
	                'A full day\u2019s start time is 10am and we finish around 4.30pm.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The day starts with a short safety talk, then its over to you.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is the most driving you will do on one of these courses - we hear this from our customers! We couldn\u2019t believe that on other days you are driven around. Throughout the day you will alternate with your passenger, believe us you\'ll be grateful for these breaks!'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'lead' },
	              _react2.default.createElement(
	                'em',
	                null,
	                '"This is real off-roading not a glorified passenger ride in mud."'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'For more information, or if you need to talk with someone about our days please call on'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _siteConfig2.default.sitePhone,
	              ' and we will answer all queries.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'aside',
	          { className: 'large-3 columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-body' },
	            _react2.default.createElement(_voucherAd2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f7a256b848db1ecd5b97.js